module.exports = __webpack_public_path__ + "static/img/6.4f06305.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting809/images/6.png
// module id = DPaC
// module chunks = 4